import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "subtitle-2 mt-2" }
const _hoisted_2 = { class: "d-flex mt-2" }
const _hoisted_3 = { class: "mt-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_tab = _resolveComponent("base-tab")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_page_header = _resolveComponent("page-header")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, { span: 24 }, {
          default: _withCtx(() => [
            _createVNode(_component_page_header, {
              "main-title": `${_ctx.$t('tenantDetails')} - ${$setup.tenant.name}`
            }, {
              tabs: _withCtx(() => [
                _createElementVNode("h4", _hoisted_1, _toDisplayString(_ctx.$t('deploymentStatus') +
                ' : ' +
                Object.keys($setup.DeploymentStatus)[$setup.tenant.deploymentStatus]), 1),
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(_component_router_link, { to: { name: 'TenantGeneral' } }, {
                    default: _withCtx(({ isExactActive }) => [
                      _createVNode(_component_base_tab, { active: isExactActive }, {
                        default: _withCtx(() => [
                          _createElementVNode("h4", null, _toDisplayString(_ctx.$t('general')), 1)
                        ]),
                        _: 2
                      }, 1032, ["active"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_router_link, { to: { name: 'TenantCompose' } }, {
                    default: _withCtx(({ isActive }) => [
                      _createVNode(_component_base_tab, { active: isActive }, {
                        default: _withCtx(() => [
                          _createElementVNode("h4", null, _toDisplayString(_ctx.$t('compose')), 1)
                        ]),
                        _: 2
                      }, 1032, ["active"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_router_link, { to: { name: 'TenantDeployments' } }, {
                    default: _withCtx(({ isActive }) => [
                      _createVNode(_component_base_tab, { active: isActive }, {
                        default: _withCtx(() => [
                          _createElementVNode("h4", null, _toDisplayString(_ctx.$t('deployments')), 1)
                        ]),
                        _: 2
                      }, 1032, ["active"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_router_link, { to: { name: 'TenantEngagements' } }, {
                    default: _withCtx(({ isActive }) => [
                      _createVNode(_component_base_tab, { active: isActive }, {
                        default: _withCtx(() => [
                          _createElementVNode("h4", null, _toDisplayString(_ctx.$t('engagements')), 1)
                        ]),
                        _: 2
                      }, 1032, ["active"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_router_link, { to: { name: 'TenantUsers' } }, {
                    default: _withCtx(({ isActive }) => [
                      _createVNode(_component_base_tab, { active: isActive }, {
                        default: _withCtx(() => [
                          _createElementVNode("h4", null, _toDisplayString(_ctx.$t('users')), 1)
                        ]),
                        _: 2
                      }, 1032, ["active"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_router_link, { to: { name: 'TenantApplications' } }, {
                    default: _withCtx(({ isActive }) => [
                      _createVNode(_component_base_tab, { active: isActive }, {
                        default: _withCtx(() => [
                          _createElementVNode("h4", null, _toDisplayString(_ctx.$t('applications')), 1)
                        ]),
                        _: 2
                      }, 1032, ["active"])
                    ]),
                    _: 1
                  }),
                  _cache[0] || (_cache[0] = _createElementVNode("div", { class: "horizontal-line mt-2" }, [
                    _createElementVNode("hr")
                  ], -1))
                ])
              ]),
              _: 1
            }, 8, ["main-title"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_router_view)
    ])
  ]))
}